<template>
  <div>
    <div style="overflow-x: scroll; overflow-y: hidden">
      <div style="width: fit-content">
        <v-card flat class="rounded-lg primary--text px-3" height="47">
          <div class="text-center d-flex align-center" style="height: 100%">
            <div class="text-start" style="width: 350px">
              {{ $t("quiz.assessment") }}
            </div>

            <div class="text-start" style="width: 250px">
              {{ $t("reports.employee") }}
            </div>

            <div class="text-start" style="width: 200px">
              {{ $t("quiz.date") }}
            </div>

            <div style="width: 150px">
              {{ $t("reports.quiz.totalMark") }}
            </div>

            <div style="width: 150px">
              {{ $t("reports.quiz.passPercentage") }}
            </div>

            <div style="width: 150px">
              {{ $t("reports.quiz.score") }}
            </div>

            <div style="width: 100px">
              {{ $t("reports.revenues.status") }}
            </div>
          </div>
        </v-card>
      </div>

      <div v-if="loading && !assessmentReports.length" class="my-16">
        <v-progress-circular indeterminate color="primary">
        </v-progress-circular>
      </div>

      <div v-else-if="!loading && assessmentReports.length">
        <div
          v-for="(quiz, index) in assessmentReports"
          :key="index"
          class="pt-5"
          style="width: fit-content"
        >
          <v-card flat class="rounded-lg textLight--text px-3">
            <div
              class="text-center d-flex align-center"
              style="min-height: 65px"
            >
              <div class="text-start text-ellipse-2" style="width: 350px">
                {{
                  quiz && quiz.quizContent
                    ? getLocalisedValue(quiz.quizContent.title)
                    : " - "
                }}
              </div>

              <div class="text-start text-ellipse-2" style="width: 250px">
                {{
                  quiz &&
                  quiz.employee &&
                  quiz.employee.user &&
                  quiz.employee.user.firstName
                    ? `${quiz.employee.user.firstName || ""} ${
                        quiz.employee.user.lastName || ""
                      }`
                    : " - "
                }}
              </div>

              <div class="text-start" style="width: 200px">
                {{
                  quiz && quiz.attempt && quiz.attempt.attemptedAt
                    ? moment(parseInt(quiz.attempt.attemptedAt)).format(
                        "DD MMM YYYY hh:mm a"
                      )
                    : " - "
                }}
              </div>

              <div style="width: 150px">
                {{
                  quiz && quiz.attempt && quiz.attempt.totalMark
                    ? quiz.attempt.totalMark
                    : " - "
                }}
              </div>

              <div style="width: 150px">
                {{
                  quiz &&
                  quiz.quizContent &&
                  quiz.quizContent.quiz &&
                  quiz.quizContent.quiz.passMark
                    ? quiz.quizContent.quiz.passMark + "%"
                    : " - "
                }}
              </div>

              <div style="width: 150px">
                {{
                  quiz && quiz.attempt && quiz.attempt.acquiredMark != null
                    ? quiz.attempt.acquiredMark
                    : " - "
                }}
              </div>

              <div style="width: 100px">
                <div v-if="quiz && quiz.attempt && quiz.attempt.status">
                  <v-icon
                    size="25"
                    color="red"
                    v-if="quiz.attempt.status === 'FAILED'"
                  >
                    mdi-close-circle-outline
                  </v-icon>

                  <v-icon
                    size="25"
                    color="success"
                    v-else-if="quiz.attempt.status === 'PASSED'"
                  >
                    mdi-check-circle-outline
                  </v-icon>
                </div>

                <div v-else>-</div>
              </div>
            </div>
          </v-card>
        </div>
      </div>

      <div
        v-else-if="!loading && !assessmentReports.length"
        class="textLight--text font-weight-medium my-16"
        align="center"
      >
        {{ $t("noItems") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssessmentReportsList",
  props: {
    assessmentReports: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: true,
      type: Boolean,
    },
  },
};
</script>
